const hasOwnProperty = Object.prototype.hasOwnProperty

if (!Object.hasOwn) {
  Object.defineProperty(Object, 'hasOwn', {
    value(object: unknown, property: PropertyKey): boolean {
      return hasOwnProperty.call(object, property)
    },
    configurable: true,
    writable: true,
  })
}

// Safari < 15.4 and older WebViews lack Array.prototype.at, which esbuild does
// not polyfill for the safari14/chrome87 build target.
if (!Array.prototype.at) {
  const at = function at<T>(this: readonly T[], index: number): T | undefined {
    const length = this.length
    let normalized = Math.trunc(index) || 0
    if (normalized < 0) normalized += length
    if (normalized < 0 || normalized >= length) return undefined
    return this[normalized]
  }

  Object.defineProperty(Array.prototype, 'at', {
    value: at,
    configurable: true,
    writable: true,
    enumerable: false,
  })
}

// Safari < 17.4 lacks Map.groupBy, which the pickup lists group days and windows with, and esbuild doesn't polyfill
// it for the safari14 build target either.
if (!Map.groupBy) {
  Object.defineProperty(Map, 'groupBy', {
    value<K, T>(items: Iterable<T>, keyOf: (item: T, index: number) => K): Map<K, T[]> {
      const groups = new Map<K, T[]>()
      let index = 0
      for (const item of items) {
        const key = keyOf(item, index++)
        const group = groups.get(key)
        if (group) group.push(item)
        else groups.set(key, [item])
      }
      return groups
    },
    configurable: true,
    writable: true,
  })
}
